import { TypedDispatch, TypedThunk } from "App/Store";
import { BRACKET_DISPUTE_LIST_ACTION } from "core/constants/Actions";
import { getBraceketDisputes } from "core/services/Bracket";

export function getBracketDisputeList(
  tournamnetId: string | number,
  params: any
): TypedThunk {
  return async (dispatch: TypedDispatch): Promise<void> => {
    dispatch({ type: BRACKET_DISPUTE_LIST_ACTION.REQUEST });
    const apiResponse = await getBraceketDisputes(tournamnetId, params);
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: BRACKET_DISPUTE_LIST_ACTION.SUCCESS,
        payload: {
          disputedBrackets: apiResponse.data.disputedBrackets,
          count: apiResponse.data.count,
          currentPage: params.page,
        },
      });
    } else {
      dispatch({
        type: BRACKET_DISPUTE_LIST_ACTION.FAILURE,
      });
    }
  };
}
